export const locale = {
  lang: 'fr-CA',
  data: {
    NOTIFICATION_CENTER: {
      TITLE: 'Notifications',
      CLOSE: 'Fermer',
      FILTER_ARIA: 'Filtrer les notifications',
      FILTER_ACTIVE: 'Actives',
      FILTER_NEW: 'Non lues',
      FILTER_ARCHIVED: 'Archivées',
      MARK_ALL_READ: 'Tout marquer comme lu',
      MARK_ALL_READ_DONE: 'Toutes les notifications sont marquées comme lues.',
      MY_PREFERENCES: 'Mes préférences de notifications',
      LIST_ARIA: 'Liste des notifications',
      OPEN: 'Ouvrir',
      MARK_READ: 'Marquer comme lu',
      MARK_UNREAD: 'Remettre en non-lu',
      ARCHIVE: 'Archiver',
      UNARCHIVE: 'Désarchiver',
      UNREAD: 'Non lue',
      READ: 'Lue',
      ARCHIVED: 'Archivée',
      SHOW_MORE: 'Afficher plus',
      SHOWN_COUNT: '{{count}} sur {{total}}',
      LOADING: 'Chargement des notifications…',
      RETRY: 'Réessayer',
      ERROR_TITLE: 'Impossible de charger les notifications',
      ERROR_MESSAGE:
        'Une erreur est survenue. Vérifiez votre connexion, puis réessayez.',
      ACTION_ERROR: "L'action n'a pas pu être effectuée. Réessayez.",
      NOT_FOUND: "Cette notification n'existe plus.",
      EMPTY_ACTIVE_TITLE: 'Aucune notification',
      EMPTY_ACTIVE:
        'Vous êtes à jour. Les nouvelles notifications apparaîtront ici.',
      EMPTY_NEW_TITLE: 'Aucune notification non lue',
      EMPTY_NEW: 'Tout a été lu.',
      EMPTY_ARCHIVED_TITLE: 'Aucune notification archivée',
      EMPTY_ARCHIVED:
        'Les notifications que vous archivez sont conservées ici.',
      SEVERITY: {
        INFO: 'Information',
        SUCCESS: 'Succès',
        WARNING: 'Avertissement',
        ERROR: 'Erreur',
      },
      PREFS: {
        TITLE: 'Mes notifications',
        INTRO:
          'Choisissez, pour chaque notification, par où vous voulez la recevoir. Vos choix ne touchent que votre compte.',
        LOADING: 'Chargement de vos préférences…',
        ERROR_TITLE: 'Impossible de charger vos préférences',
        ERROR_MESSAGE:
          'Une erreur est survenue. Vérifiez votre connexion, puis réessayez.',
        RETRY: 'Réessayer',
        EMPTY_TITLE: 'Aucune notification offerte',
        EMPTY:
          "Aucune notification n'est offerte à votre compte pour le moment.",
        EPHEMERAL_GROUP: 'Messages éclair',
        EPHEMERAL_HINT:
          "Un message éclair s'affiche quelques secondes à l'écran pendant que vous utilisez l'application. Il n'est pas conservé.",
        LOCKED: 'Réglage fixé par votre organisation',
        LOCKED_HINT:
          'Votre organisation a fixé ce réglage : vous ne pouvez pas le modifier.',
        CUSTOMIZED: 'Choix personnel',
        RESET_ROW: "Revenir au réglage de l'organisation",
        RESET_PENDING: "Retour au réglage de l'organisation à la sauvegarde",
        CHANNEL_ARIA: '{{channel}} — {{label}}',
        SAVE: 'Sauvegarder',
        CANCEL: 'Annuler',
        CANCEL_CHANGES: 'Annuler les changements',
        UNSAVED_ONE: '1 changement à sauvegarder',
        UNSAVED_MANY: '{{count}} changements à sauvegarder',
        SAVED: 'Vos préférences de notifications sont sauvegardées.',
        ERR_NCP0001:
          "Une de ces notifications n'existe plus. La liste a été rechargée.",
        ERR_NCP0002:
          'Votre organisation ne permet plus de modifier une de ces notifications. La liste a été rechargée.',
        ERR_NCP0003:
          "Un des canaux choisis n'est plus offert pour cette notification. La liste a été rechargée.",
      },
      ORG: {
        TITLE: "Notifications de l'organisation",
        INTRO:
          'Décidez quelles notifications votre organisation envoie, à quels rôles, et par où elles sont envoyées par défaut. Chaque utilisateur peut ensuite ajuster ses propres choix si vous le permettez.',
        LOADING: 'Chargement des réglages…',
        ERROR_TITLE: 'Impossible de charger les réglages',
        ERROR_MESSAGE:
          'Une erreur est survenue. Vérifiez votre connexion, puis réessayez.',
        FORBIDDEN:
          "Seuls les propriétaires et les administrateurs peuvent modifier les notifications de l'organisation.",
        RETRY: 'Réessayer',
        EMPTY_TITLE: 'Aucune notification à configurer',
        EMPTY: "Aucune notification n'est offerte à votre organisation.",
        EPHEMERAL_GROUP: 'Messages éclair',
        ENABLED: 'Activée',
        DISABLED: 'Désactivée',
        ENABLE_ARIA: 'Activer ou désactiver la notification « {{label}} »',
        DISABLED_HINT:
          'Cette notification est désactivée : personne ne la reçoit.',
        TARGET_ROLES: 'Rôles visés',
        ALL_ROLES: 'Tous les rôles',
        LAST_ROLE_HINT:
          "Au moins un rôle doit rester coché. Pour ne l'envoyer à personne, désactivez la notification.",
        USERS_AUDIENCE_HINT:
          "Cette notification est envoyée aux personnes concernées : le choix des rôles ne s'applique pas.",
        DEFAULT_CHANNELS: 'Canaux activés par défaut',
        ALLOW_USER_OVERRIDE: 'Permettre à chaque utilisateur de choisir',
        ALLOW_USER_OVERRIDE_HINT:
          "Si cette option est décochée, les canaux par défaut s'appliquent à tous, sans exception.",
        CUSTOMIZED: 'Personnalisée',
        RESET: 'Revenir aux valeurs par défaut',
        SAVED: 'Réglage sauvegardé.',
        RESET_DONE: 'La notification est revenue aux valeurs par défaut.',
        ERR_NCS0002:
          "Un des canaux choisis n'est pas offert pour cette notification.",
        ERR_NOT_FOUND: "Cette notification n'existe plus.",
      },
    },
  },
};
